document.addEventListener("DOMContentLoaded", () => {

  const locale = window.Shopify?.routes?.root.replace(/\/$/, "") || "";

  document.querySelectorAll(".dm-featured-products").forEach(async (section) => {

    const grid = section.querySelector(".dm-featured-products__grid");

    if (!grid) return;

    const handles = grid.dataset.products
      .replace(/<!--.*?-->/g, "")
      .split(",")
      .map(handle => handle.trim())
      .filter(Boolean);

    for (const handle of handles) {

      try {

        const response = await fetch(`${locale}/products/${handle}.js`);

        if (!response.ok) continue;

        const product = await response.json();

        const image = product.images[0] + "&width=500";

        const card = document.createElement("a");

        card.href = `${locale}/products/${product.handle}`;

        card.className = "dm-featured-card";

        card.innerHTML = `

<div class="dm-featured-card__image">

<img
loading="lazy"
src="${image}"
width="500"
height="500"
alt="${product.title}">

</div>

<div class="dm-featured-card__title">

${product.title}

</div>

`;

        grid.append(card);

      } catch (e) {

        console.error("Error cargando", handle, e);

      }

    }

  });

});